const EventSubscriber = (): {
  getEvent: (name: string) => (event: Event) => void;
  subscribe: (name: string, eventHandler: (event: Event) => void) => string;
  unsubscribe: (name: string) => void;
  checkSubscription: (name: string) => boolean;
  evoke: (name: string, ...props: Array<object>) => unknown;
} => {
  const eventTracker = {};

  const subscribe = (
    name: string,
    eventHandler: (event: Event) => void
  ): string => {
    eventTracker[name] = eventHandler;
    return name;
  };

  const unsubscribe = (name: string): void => {
    delete eventTracker[name];
  };

  const getEvent = (name: string): ((event: Event) => void) =>
    eventTracker[name];

  const checkSubscription = (name: string): boolean =>
    typeof eventTracker[name] !== 'undefined';

  const evoke = (name: string, ...props: Array<object>): unknown => {
    if (typeof eventTracker[name] === 'undefined') {
      throw new Error(
        `Could not evoke event. Event of name [${name}] is not being tracked.`
      );
    }

    return eventTracker[name](...props);
  };

  return {
    getEvent,
    subscribe,
    unsubscribe,
    checkSubscription,
    evoke,
  };
};

export default EventSubscriber;
